import React from 'react'
import { Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  verticalDivider: {
    background: theme.palette.card.divider,
    display: 'none',
    height: '1em',
    opacity: 1,

    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
}))

export default function VerticalDivider() {
  const classes = useStyles()

  return <Divider className={classes.verticalDivider} orientation="vertical" />
}
